import request from '@/utils/request'


// 查询订单列表
export function listGoodsOrder(query) {
  return request({
    url: '/user/goods-order/list',
    method: 'get',
    params: query
  })
}

// 查询订单分页
export function pageGoodsOrder(query) {
  return request({
    url: '/user/goods-order/page',
    method: 'get',
    params: query
  })
}

// 查询订单详细
export function getGoodsOrder(data) {
  return request({
    url: '/user/goods-order/detail',
    method: 'get',
    params: data
  })
}

// 新增订单
export function addGoodsOrder(data) {
  return request({
    url: '/user/goods-order/add',
    method: 'post',
    data: data
  })
}

// 修改订单
export function updateGoodsOrder(data) {
  return request({
    url: '/user/goods-order/edit',
    method: 'post',
    data: data
  })
}

// 删除订单
export function delGoodsOrder(data) {
  return request({
    url: '/user/goods-order/delete',
    method: 'post',
    data: data
  })
}

// 待发稿(4) → 已收稿(5)
export function markGoodsOrderDraftReceived(data) {
  return request({
    url: '/user/goods-order/mark-draft-received',
    method: 'post',
    data: data
  })
}

// 待发稿(4) 更新收稿邮箱 submission_email（可清空）
export function updateGoodsOrderSubmissionEmail(data) {
  return request({
    url: '/user/goods-order/update-submission-email',
    method: 'post',
    data: data
  })
}

// 已收稿(5) → 生产中(6)
export function markGoodsOrderProducing(data) {
  return request({
    url: '/user/goods-order/mark-producing',
    method: 'post',
    data: data
  })
}

// 生产中(6) 更新生产环节 production_status：1-8
export function updateGoodsOrderProductionStatus(data) {
  return request({
    url: '/user/goods-order/update-production-status',
    method: 'post',
    data: data
  })
}

// 生产中(6)：提交多条箱规（覆盖原箱规）并转待发货(7)
export function submitGoodsOrderBoxesAwaitShip(data) {
  return request({
    url: '/user/goods-order/submit-boxes-await-ship',
    method: 'post',
    data: data
  })
}

// 待发货(7) 且非首款：已发货(9)
export function markGoodsOrderShippedFromAwaitShip(data) {
  return request({
    url: '/user/goods-order/mark-shipped-from-await-ship',
    method: 'post',
    data: data
  })
}

// 待发货(7) 且首款(1)：待收尾款(8)
export function markGoodsOrderAwaitFinalPaymentFromAwaitShip(data) {
  return request({
    url: '/user/goods-order/mark-await-final-payment-from-await-ship',
    method: 'post',
    data: data
  })
}

// 已发货(9) → 已完成(10)
export function markGoodsOrderCompletedFromShipped(data) {
  return request({
    url: '/user/goods-order/mark-completed-from-shipped',
    method: 'post',
    data: data
  })
}
